export default __webpack_public_path__ + "7c32b835b21de0c4dc6aa3a5998d2b1a.png";